export let StatusDTO = /*#__PURE__*/function (StatusDTO) {
  StatusDTO["PendingSync"] = "pendingSync";
  StatusDTO["Synced"] = "synced";
  StatusDTO["SyncFailed"] = "syncFailed";
  StatusDTO["PaymentFailed"] = "paymentFailed";
  StatusDTO["Voided"] = "voided";
  StatusDTO["Paid"] = "paid";
  StatusDTO["Refunded"] = "refunded";
  StatusDTO["RefundFailed"] = "refundFailed";
  return StatusDTO;
}({});